import React, { Fragment, memo, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { change, Field } from 'redux-form';
import PropTypes from 'prop-types';
import Select from '../../../shared/components/form/Select';
import TimetableDisciplineDraggable from './TimetableDisciplineDraggable';
import GraphQL from '../../../GraphQL';
import { employeeListBySubjectId } from '../../../shared/queries/Employee';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import InfoCardsSubjects from './InfoCardsSubjects';
import { roomListOnlyActives } from '../../../shared/queries/Room';

const TimetableGrid = (props) => {
  const {
    t,
    dispatch,
    selectedAcademicCalendar,
    disciplinesTimetable,
    timetable,
    loadTimetableBySchoolClass,
    selectedStep,
    dto,
    selectedClassShift,
    timetableGrid,
    setTimetableGrid,
  } = props;

  const [data, setData] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [employeeListBySubject, setEmployeeListBySubject] = useState([]);

  const loadEmployeeListBySubject = (id) => {
    const query = employeeListBySubjectId(id);
    return GraphQL(query, {})
      .then((res) => {
        return res.employeeListBySubject.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllRooms = () => {
    const query = roomListOnlyActives();
    GraphQL(query, {})
      .then((res) => {
        setRooms(res.roomListByFilter);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllEmployeeListBySubject = () => {
    const list = [];
    disciplinesTimetable.forEach(async ({ id }) => {
      const employeeListBySubjectUnResolvePromise = loadEmployeeListBySubject(
        id
      ).then((item) => ({ id, item }));
      list.push(employeeListBySubjectUnResolvePromise);
    });
    Promise.all(list).then((item) => {
      setEmployeeListBySubject(item);
    });
  };

  useEffect(() => {
    dispatch(change('SchoolClassForm', 'disciplines', disciplinesTimetable));
    loadAllEmployeeListBySubject();
    loadAllRooms();
  }, [disciplinesTimetable]);

  useEffect(() => {
    setData(timetable);
  }, [timetable]);

  useEffect(() => {
    dispatch(change('SchoolClassForm', 'cardsSubjects', data));
  }, [data]);

  useEffect(() => {
    if (selectedStep && selectedStep.id) {
      loadTimetableBySchoolClass(dto.id, {
        cycleQuantity: selectedStep.cycleQuantity,
        id: selectedStep.id,
      });
    }
  }, [selectedStep, selectedClassShift, selectedAcademicCalendar]);

  return (
    <Fragment>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.subjects')}</span>
        <div className="form_form-group-field">
          <Field
            name="disciplines"
            component={Select}
            options={[]}
            isMulti
            isDisabled
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.complete-information-discipline')}
        </span>
        <div className="form_form-group-field">
          <Field
            name="cardsSubjects"
            component={InfoCardsSubjects}
            data={data}
            onChangeData={setData}
            employeeListBySubject={employeeListBySubject}
            rooms={rooms}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.build-timetable-discipline-distribution')}
        </span>
        <div className="form_form-group-field">
          <Field
            name="timetableGrid"
            component={TimetableDisciplineDraggable}
            cardsSubjects={data}
            onChangeCardSubjects={setData}
            timetableGrid={timetableGrid}
            setTimetableGrid={setTimetableGrid}
          />
        </div>
      </div>
    </Fragment>
  );
};

TimetableGrid.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  loadTimetableBySchoolClass: PropTypes.func.isRequired,
  selectedAcademicCalendar: PropTypes.shape(PropTypes.shape).isRequired,
  selectedStep: PropTypes.shape(PropTypes.shape).isRequired,
  selectedClassShift: PropTypes.shape(PropTypes.shape).isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  timetableGrid: PropTypes.shape(PropTypes.shape).isRequired,
  disciplinesTimetable: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
  timetable: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  setTimetableGrid: PropTypes.func.isRequired,
};

export default withTranslation('common')(memo(TimetableGrid));
